module.exports = __webpack_public_path__ + "img/paperang.7ec60af9.png";